import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-view-data',
  templateUrl: './view-data.component.html',
  styleUrls: ['./view-data.component.css']
})
export class ViewDataComponent implements OnInit {
  uid: any;
  accountId: any;
  fileDetails: any;

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,private accountService: AccountService,) { }

  ngOnInit(): void {
    this.uid = this.data.uid;
    this.accountId = this.data.accountId;
    this.getDetailsByUid()
  }
  getDetailsByUid(){
    this.accountService.getFileDetails( this.accountId,this.uid)
        .subscribe(
          res => {
            this.fileDetails = res;
          }
        );
  }
}
